import { render, staticRenderFns } from "./viewImgs.vue?vue&type=template&id=2ed8bc34&scoped=true"
import script from "./viewImgs.vue?vue&type=script&lang=js"
export * from "./viewImgs.vue?vue&type=script&lang=js"
import style0 from "./viewImgs.vue?vue&type=style&index=0&id=2ed8bc34&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed8bc34",
  null
  
)

export default component.exports